<template>
  <div
    class="fixed w-full h-full p-10 flex left-0 top-0"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999999 !important;
      backdrop-filter: blur(5px);
    "
    @click.self="closeModalView"
  >
    <div
      class="flex-1 bg-black rounded-lg flex shadow-md overflow-hidden relative"
    >
      <div class="h-full w-full flex flex-col bg-white">
        <div
          class="w-full bg-grey-light flex p-4 font-bold text-black"
          style="height: 45px"
        >
          {{ `Share Live Tracking` }}
        </div>
        <div class="flex-1 px-4 py-10">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-half">
              <b> Asset : {{ data.assetName }}</b>
            </div>
            <div class="vx-col md:w-1/4 w-half">
              <b>Link Expiry Time (Hours)</b>
              <vs-input v-model="opts.validity" type="number" />
            </div>

            <div class="vx-col md:w-1/2 w-half">
              <vs-checkbox v-model="opts.tnc"
                >NOTE: I understand and agree that Location Sharing link is
                publicly available & expiry time cannot be changed after
                generation.</vs-checkbox
              >
            </div>
          </div>
          <vs-button
            v-if="state == 'pre-generation'"
            @click="generateLink"
            size="small"
            >Generate Link</vs-button
          >
          <br />
          <div
            style="align-items: center; justify-content: center"
            v-if="state == 'post-generation'"
          >
            <feather-icon
              style="color: green"
              icon="CheckCircleIcon"
              size="8"
            />
            <span class="mr-25 align-middle"
              ><a :href="url" target="_blank">{{ url }}</a></span
            >
          </div>
          <br />
          <div
            style="align-items: center; justify-content: center"
            v-if="state == 'post-generation'"
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/6 w-half">
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-copy"
                  size="small"
                  @click="action('clipboard')"
                  >Copy to Clipboard</vs-button
                >
              </div>
              <div class="vx-col md:w-1/6 w-half">
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-message-circle"
                  size="small"
                  @click="action('whatsapp')"
                  >Share in Whatsapp</vs-button
                >
              </div>
            </div>
          </div>
          <br />

          <br /><br />
          <br /><br />
          <br /><br />
        </div>
      </div>
      <i
        @click="closeModalView"
        class="mr-4 mt-4 vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
        style="
          background: rgb(255, 255, 255);
          position: absolute;
          right: 0;
          top: 0;
        "
        >close</i
      >
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    vSelect,

    // moment,
  },
  watch: {
    // data: {
    //   handler() {
    //     this.getChart();
    //   },
    // },
    // deep: true,
  },
  data() {
    return {
      opts: {
        tnc: false,
        validity: 1,
      },
      url: null,
      state: 'pre-generation',
    };
  },
  methods: {
    closeModalView() {
      this.$emit('close-modal');
    },
    generateLink() {
      var self = this;
      if (this.opts.tnc != true) {
        alert('Read & Agree note before generating link..');
        return;
      } else {
        let currTimeInMs = Date.now();
        let expiryTimeInMs = currTimeInMs + self.opts.validity * 60 * 60 * 1000;
        const myObject = {
          unitId: self.data.unitId,
          assetId: self.data.assetId,
          assetName: self.data.assetName,
          expiryTimeInMs: expiryTimeInMs,
        };
        const secretKey = 'super-secret-key';

        self.encryptObject(myObject, secretKey).then((encryptedString) => {
          self.url =
            'https://fleets.igeotechgps.com/live-location/' + encryptedString;
          self.state = 'post-generation';
          alert('Link is ready!');
          // self.decryptObject(encryptedString, secretKey).then(decryptedObject => {
          //  console.log('Decrypted Object:', decryptedObject);
          // });
        });
      }
    },
    async encryptObject(obj, secretKey) {
      const serializedObject = JSON.stringify(obj);
      const encoder = new TextEncoder();

      // Convert the secret key to ArrayBuffer
      const keyBuffer = await crypto.subtle.importKey(
        'raw',
        encoder.encode(secretKey),
        'AES-GCM',
        true,
        ['encrypt'],
      );

      // Generate a random IV (Initialization Vector)
      const iv = crypto.getRandomValues(new Uint8Array(12));

      // Encrypt the object
      const encryptedData = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        keyBuffer,
        encoder.encode(serializedObject),
      );

      // Combine IV and encrypted data into a single Uint8Array
      const resultArray = new Uint8Array(iv.length + encryptedData.byteLength);
      resultArray.set(iv);
      resultArray.set(new Uint8Array(encryptedData), iv.length);

      // Convert the result to a URL-safe Base64 string
      const base64String = btoa(String.fromCharCode(...resultArray))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

      return base64String;
    },
    async decryptObject(encryptedString, secretKey) {
      // Convert the URL-safe Base64 string to a regular Base64 string
      const encoder = new TextEncoder();
      const base64String = encryptedString
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(
          encryptedString.length + ((4 - (encryptedString.length % 4)) % 4),
          '=',
        );

      const decoder = new TextDecoder();

      // Convert the secret key to ArrayBuffer
      const keyBuffer = await crypto.subtle.importKey(
        'raw',
        encoder.encode(secretKey),
        'AES-GCM',
        true,
        ['decrypt'],
      );

      // Extract IV and encrypted data from the Base64 string
      const arrayBuffer = new Uint8Array(
        [...atob(base64String)].map((char) => char.charCodeAt(0)),
      );

      // Separate IV and encrypted data
      const iv = arrayBuffer.slice(0, 12);
      const encryptedData = arrayBuffer.slice(12);

      // Decrypt the data
      const decryptedData = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv },
        keyBuffer,
        encryptedData,
      );

      // Convert the decrypted data to an object
      const decryptedObject = JSON.parse(decoder.decode(decryptedData));

      return decryptedObject;
    },
    action(type) {
      if (type == 'clipboard') {
        const textarea = document.createElement('textarea');
        textarea.value = this.url;
        // textarea.style.visibility = 'hidden';
        textarea.id = 'temp-text';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            alert('Link copied to clipboard!');
          } else {
            console.error('Unable to copy text to clipboard.');
          }

          var elem = document.getElementById('temp-text');
          return elem.parentNode.removeChild(elem);
        } catch (error) {
          console.error('Unable to copy text to clipboard.', error);
          var elem = document.getElementById('temp-text');
          return elem.parentNode.removeChild(elem);
        } finally {
        }
      } else if (type == 'whatsapp') {
        window.open(
          'https://api.whatsapp.com/send?text=' +
            this.data.assetName +
            ' Live Location (active for ' +
            this.opts.validity +
            ' hours) - Link: ' +
            this.url,
          '_blank',
        );
      }
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.data) {
    //     this.getChart();
    //   }
    // });
  },
};
</script>

<style scoped></style>
